import { render, staticRenderFns } from "./EbitdaBottomFive.vue?vue&type=template&id=83064482"
import script from "./EbitdaBottomFive.vue?vue&type=script&lang=js"
export * from "./EbitdaBottomFive.vue?vue&type=script&lang=js"
import style0 from "./EbitdaBottomFive.vue?vue&type=style&index=0&id=83064482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports